import { Technology } from '@node/wam-audience-builder'
import { toNumber } from 'lodash'

const helpers = {
    commitError: (commit, action, error) => {
        commit(
            action,
            {
                type: 'error',
                message: error.message
            },
            { root: true }
        )
        throw error
    },

    buildRoutes: () => {
        const route = '/common_project/browsers.json'
        const params = {
            params: {
                list_limit: 0,
                conditions: {
                    deprecated: 'NO'
                }
            }
        }
        return { route, params }
    },
    parseData: (data, countryCode2) => {
        const _data = []
        for (const val of data) {
            const wamData = {
                id: toNumber(val.id),
                label: val.label,
                isSelectable: true,
                hasChild: false,
                parentJsonKeyName: 'techno_browser',
                jsonKey: {
                    ids: ['browser', toNumber(val.id), countryCode2],
                    name: 'techno_browser_' + val.id,
                    type: 'Techno',
                    subType: 'browser'
                }
            }
            _data.push(wamData)
        }
        return _data.sort((a, b) => a.label.localeCompare(b.label, undefined, { ignorePunctuation: true, numeric: true }))
    },

    instanciateAll: (browsers, countryCode) => {
        return browsers.map(
            browser =>
                new Technology({
                    id: browser.id,
                    label: browser.label,
                    subCategory: 'browser',
                    path: ['Technology', 'Browsers'],
                    countryCode
                })
        )
    }
}

export default helpers
